import React, {useEffect, useState, useRef} from "react";
import {Pagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import { useSwiper } from 'swiper/react';
import PhotoSelector from "../Forms/PhotoSelector";
import {sliceIntoChunks} from "../../../utils/helpers";
import Character from "../../../pages/Setting/components/children_setting/Character";

const SwiperScrollToFirst = ({ show }) => {
  const swiper = useSwiper();

    useEffect(() => {
        if (show) {
            swiper.slideTo(0)
        }
    },[show])

  return null
};

const SwiperChildren = ({
    characterModels,
    getIdCharacter,
    idCharacterActive,
    onSlideChange,
    show,
}) => {

    const chunkDataSwiper = 12;

    const [dataCharacters,setDataCharacters] = useState([]);

    const [idCharacters, setIdCharacters] =  useState([]);

    useEffect(() => {
        if(idCharacterActive && idCharacterActive.length > 0){
            setIdCharacters(idCharacterActive);
        }
    },[idCharacterActive])

    useEffect(() => {
        if(characterModels.length && characterModels.length > 0 ){
            let chunkData = sliceIntoChunks(characterModels,chunkDataSwiper);
            setDataCharacters(chunkData);
        }
    },[characterModels]);

    const renderSliderItem = (items) => {
        return items.map((item, key) => {
            return (
                <div className="col-4 text-center" key={`item_${key}`}>
                    <div className="item">
                        <div className="img">
                            <PhotoSelector
                                id={`js-baby-${key}`}
                                name={`input-baby-${key}`}
                                value={item.id}
                                path={item.featured_image ? item.featured_image_url.thumbnail : ''}
                                handleChange={handleChangeSelectFavorite}
                                checked={idCharacters.includes(item.id)}
                            />
                        </div>
                        <div className="description">
                            <span>{item.name}</span>
                        </div>
                    </div>
                </div>
            )
        })
    }

    const handleChangeSelectFavorite = (e, value) => {

        console.log(idCharacters, 'handleChangeSelectFavorite');
        let findId = idCharacters.find(find => find == value);
        console.log(findId, value, 'findId');
        if(findId){

            const index = idCharacters.indexOf(findId);

            let idCharactersTemporary = [...idCharacters];

            if (index > -1) {
                idCharactersTemporary.splice(index, 1);
            }
            console.log(idCharactersTemporary, 'idCharactersTemporary');
            setIdCharacters(idCharactersTemporary)
            getIdCharacter(idCharactersTemporary)
        }else{
            console.log(idCharacters,value, 'setIdCharacters getIdCharacter');
            setIdCharacters([...idCharacters,value]);
            getIdCharacter([...idCharacters,value]);
        }
    }

    return (
        <Swiper
            pagination={true}
            modules={[Pagination]}
            className="children-swiper"
            onSlideChange={onSlideChange}
        >
            <SwiperScrollToFirst show={show}></SwiperScrollToFirst>
            {dataCharacters.map((items,index) => {
                return (
                    <SwiperSlide
                        key={index}
                    >
                        <div className={'row m-0 p-0'}>
                            {renderSliderItem (items)}
                        </div>

                    </SwiperSlide>
                )
            })}


        </Swiper>
    )
}
SwiperChildren.defaultProps = {
    idCharacterActive: [],
    onSlideChange : () => {}
};

export default SwiperChildren;


